import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agentsApi, CreateAIAgentRequest, AIAgentResponse } from '../services/agentsApi';
import { toast } from 'sonner';

/**
 * Hook para criar novo agente
 *
 * @example
 * const createAgent = useCreateAgent();
 *
 * const handleSubmit = async (data) => {
 *   try {
 *     await createAgent.mutateAsync(data);
 *     navigate('/automation/ai-agents');
 *   } catch (error) {
 *     // Error já tratado automaticamente
 *   }
 * };
 */
export const useCreateAgent = () => {
  const queryClient = useQueryClient();

  return useMutation<AIAgentResponse, Error, CreateAIAgentRequest>({
    mutationFn: (data) => agentsApi.create(data),
    onSuccess: () => {
      // Invalidate queries para refetch
      queryClient.invalidateQueries({ queryKey: ['ai-agents'] });
      toast.success('Agente criado com sucesso!');
    },
    onError: (error) => {
      toast.error(`Erro ao criar agente: ${error.message}`);
    },
  });
};
